/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the Scoring Legend on each race card to see the exact point values. Compare drivers across races to spot consistent performers and find value picks whose points outperform their price.`)
};

const es_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la Leyenda de Puntuación en cada tarjeta de carrera para ver los valores exactos. Compara pilotos entre carreras para encontrar rendimientos consistentes y descubrir picks de valor cuya puntuación supera su precio.`)
};

const de_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze die Scoring-Legende auf jeder Rennkarte, um die genauen Punktwerte zu sehen. Vergleiche Fahrer über Rennen hinweg, um konstante Performer zu finden und Value-Picks zu entdecken, deren Punkte ihren Preis übertreffen.`)
};

const nl_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik de Scorelegenda op elke racekaart om de exacte puntwaarden te zien. Vergelijk coureurs over races heen om consistente presteerders te vinden en waardevolle picks te ontdekken waarvan de punten hun prijs overtreffen.`)
};

const fr_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez la Légende de Scoring sur chaque carte de course pour voir les valeurs exactes. Comparez les pilotes à travers les courses pour repérer les performeurs réguliers et trouver les picks de valeur dont les points surpassent leur prix.`)
};

const it_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la Legenda Punteggio su ogni scheda gara per vedere i valori esatti dei punti. Confronta i piloti tra le gare per trovare i più costanti e scoprire scelte di valore i cui punti superano il loro prezzo.`)
};

const pt_br2_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a Legenda de Pontuação em cada card de corrida para ver os valores exatos. Compare pilotos entre corridas para encontrar desempenhos consistentes e descobrir escolhas de valor cujos pontos superam o preço.`)
};

const pt_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a Legenda de Pontuação em cada cartão de corrida para ver os valores exatos. Compare pilotos entre corridas para encontrar desempenhos consistentes e descobrir escolhas de valor cujos pontos superam o seu preço.`)
};

const ja_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各レースカードのスコアリング凡例で正確なポイント値を確認してください。レース間でドライバーを比較し、安定したパフォーマーを見つけ、ポイントが価格を上回るバリューピックを発見しましょう。`)
};

const zh_f1_points_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用每张比赛卡片上的计分说明查看确切的分值。跨比赛比较车手，找到稳定的高分选手和积分超过价格的超值选择。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_how_p3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_how_p3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_how_p3", locale)
	if (locale === "en") return en_f1_points_how_p3(inputs)
	if (locale === "es") return es_f1_points_how_p3(inputs)
	if (locale === "de") return de_f1_points_how_p3(inputs)
	if (locale === "nl") return nl_f1_points_how_p3(inputs)
	if (locale === "fr") return fr_f1_points_how_p3(inputs)
	if (locale === "it") return it_f1_points_how_p3(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_how_p3(inputs)
	if (locale === "pt") return pt_f1_points_how_p3(inputs)
	if (locale === "ja") return ja_f1_points_how_p3(inputs)
	return zh_f1_points_how_p3(inputs)
};